import React from 'react';
import { Component, PuzzleCheckbox } from "puzzle";

type STATE = {
  checked: boolean
}

class PreviewTask extends Component<STATE, null> {
  public state = {
    checked: false
  };

  /**
   * On checkbox change handler
   * @param e
   */
  onChange = (e: any) => {
    const { value } = e;
    this.setState({
        checked: value
      },
      () => this.dispatch('changeConfirmButton', '', { buttonDisabled: this.state.checked })
    );
  };

  renderBody = () => {
    const { checked } = this.state;

    return (
      <div className={'tp-warning-text'}>
        <span>
          <div>
            {this.translate('text',  { className: 'tp-text-semibold' })}
          </div>
          <div className={'tp-checkbox-container'}>
            <PuzzleCheckbox
              checked={checked}
              label={this.translate('cbDescription')}
              onChange={this.onChange}
            />
          </div>
        </span>
      </div>
    )
  }
}

export default PreviewTask;
